<app-banner [heading]="'SCHOOL UNIFORM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= Features Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6">
            <img src="assets/img/rules/Schoolunifrom.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h3><b>SUMMER UNIFORM (I to X )</b></h3> <br>
			<h4>GIRLS</h4>
				1. Pink half sleeves shirt with school logo. <br>
				2. Grey box pleated Skirt ( I to VII)<br>
				3. Grey trousers/Grey box pleated skirt(IX-X) <br>
				4. School belt, I card , White ribbon or band and Navy-Blue socks with pink stripes. <br>
				5. Black Leather Shoes with velcro(I-VIII), Black Leather Shoes with Buckle (IX-X) <br> <br>
			<h4>BOYS</h4>
				1. Pink half sleeves shirt with school logo. <br>
				2. Grey  shorts (I to V) <br>
				3. Grey  trousers (VI to X)<br>
				4. School belt, I card and Navy-Blue socks with  Pink stripes. <br>
				5. Black Leather Shoes with velcro(I-VIII), Black Leather Shoes with laces (IX-X).<br>
				6. Pink  dastar/Turban for sikh boys.<br>
			
          </div>
		  </div>
		  <div class="row feature-item">
          <div class="col-lg-6">
            <img src="assets/img/rules/houseunifrom.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
           <h3><br><b>HOUSE UNIFORM FOR SUMMER(I to X)</b></h3> <br>
			<p>Wordsworth House: Green<br>
				Coleridge House: Pink <br>
				Shelley House: Orange <br>
				Shakespear House: Blue <br>
			</p><h4>GIRLS </h4>
				1. House colour half sleeves T-Shirt with school logo. <br>
				2. White box pleated Skirt ( I to VIII)<br>
				3. White trousers/White box pleated skirt(IX-X) <br>
				4. School belt, I card , White ribbon or band and White socks . <br>
				5. White Leather Shoes with velcro(I-X) <br> <br>
			<h4>BOYS</h4>
				1. Housecolour half sleeves T-shirt with school logo. <br>
				2. White  shorts (I to V) <br>
				3. White  trousers (VI to X)<br>
				4. School belt, I card and White socks. <br>
				5. White Leather Shoes with velcro(I-X).<br>
				6. White  dastar/Turban for sikh boys.<br>
			
          </div>
		  </div>
		 <div class="row feature-item">
          <div class="col-lg-6">
            <img src="assets/img/rules/uniform1.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h3><b>SUMMER UNIFORM (PRE-PRIMARY)</b></h3> <br>
			<h4>GIRLS</h4>
				1. Pink half sleeves shirt with school logo. <br>
				2. Grey box pleated Skirt<br>
				3. School belt, I card , White ribbon or band and Navy-Blue socks with pink stripes. <br>
				4. Black Leather Shoes with velcro <br> <br>
			<h4>BOYS</h4>
				1. Pink half sleeves shirt with school logo. <br>
				2. Grey  shorts <br>
				3. School belt, I card and Navy-Blue socks with  Pink stripes. <br>
				4. Black Leather Shoes with velcro <br>
				5. Pink  dastar/Turban for sikh boys.<br>
			
          </div>
		</div>
		
		  		<div class="row feature-item">
          <div class="col-lg-6">
            <img src="assets/img/rules/pre-primaryuniform.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h4><b>PRE-PRIMARY (WEDNESDAY &amp; SATURDAY UNIFORM)</b></h4> <br>
			<h4></h4>
				Class Colour   <br>
				Pre-Nursery :- Orange<br>
				Nursery :- Green <br>
				LKG :- Pink <br>
				UKG :- Blue <br> <br>
				<h4>Boys</h4>
				1. Class colour T-shirt with denim collar. <br>
				2. Denim Shorts. <br>
				3. I card and White Socks. <br>
				4. Black Leather Shoes with velcro <br>
				5. Class Colour  dastar for sikh boys.<br><br>
				
				<h4>Girls</h4>
				1. Class colour T-shirt with denim collar. <br>
				2. Denim Skirt. <br>
				3. I card and White Socks. <br>
				4. Black Leather Shoes with velcro <br>
			
          </div>
		  </div>
		  
        </div>
	
	</section>

<section id="why-us" class="why-us">
      <div class="container">

        <header class="section-header">
          <h2><b>Winter Uniform (Pre-Primary to X )</b></h2>
        </header>

        <div class="row">

          <div class="col-lg-6">
		  
		  
            <div class="why-us-img">
    <!-- <section id="whyus-details" class="whyus-details">
      <div class="container">

        <div class="whyus-details-container">

          <div class="owl-carousel portfolio-details-carousel owl-loaded owl-drag">
            
            
            
			
			
			
            <div class="owl-stage-outer">
              <div class="owl-stage" style="transform: translate3d(-2550px, 0px, 0px); transition: all 0.25s ease 0s; width: 6120px;">
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u6.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u5.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u4.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item" style="width: 510px;">
                      <img src="assets/img/rules/u2.jpg" class="img-fluid" alt="Tagore Global School Kurukshetra">
                  </div>
                  <div class="owl-item" style="width: 510px;">
                      <img src="assets/img/rules/u1.jpg" class="img-fluid" alt="Best CBSE School in Kurukshetra">
                  </div>
                  <div class="owl-item active" style="width: 510px;">
                      <img src="assets/img/rules/u3.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item" style="width: 510px;">
                      <img src="assets/img/rules/u6.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item" style="width: 510px;">
                      <img src="assets/img/rules/u5.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item" style="width: 510px;">
                      <img src="assets/img/rules/u4.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u2.jpg" class="img-fluid" alt="Tagore Global School Kurukshetra">
                  </div>
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u1.jpg" class="img-fluid" alt="Best CBSE School in Kurukshetra">
                  </div>
                  <div class="owl-item cloned" style="width: 510px;">
                      <img src="assets/img/rules/u3.jpg" class="img-fluid" alt="Best CBSE School in Haryana">
                  </div>
              </div>
            </div>
            <div class="owl-nav disabled">
                <button type="button" role="presentation" class="owl-prev"><span aria-label="Previous">‹</span></button><button type="button" role="presentation" class="owl-next"><span aria-label="Next">›</span></button></div><div class="owl-dots"><button role="button" class="owl-dot"><span></span></button><button role="button" class="owl-dot"><span></span></button><button role="button" class="owl-dot active"><span></span></button><button role="button" class="owl-dot"><span></span></button><button role="button" class="owl-dot"><span></span></button><button role="button" class="owl-dot"><span></span></button></div></div>
		</div>
		</div>
    </section> -->
	
    <div id="showcase">
        <div class="container">
          <div id="showcaseCarousel" class="carousel slide" data-bs-ride="carousel" >
            <!-- <div class="carousel-indicators">
              <button type="button" data-bs-target="#showcaseCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}"  attr.data-bs-slide-to="{{i}}" ></button>
            </div> -->
            <div class="carousel-inner">
              <div class="carousel-item" *ngFor="let img of imgUrl; let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                <div class="container-fluid" id="loader" *ngIf="isLoading[i]">
                  <app-loader></app-loader>
                </div>
                <img  [src]="img" alt="Slider" class="img-fluid" [ngStyle]="{visibility:isLoading[i]?'hidden':'visible'}"
                (load)="hideLoader(i)" (error)="hideLoader(i)">
              </div>
              
            </div>
            <!-- <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button> -->
          </div>
          
          
        </div>
      </div>





</div>
    </div>

          <div class="col-lg-6">
            <div class="why-us-content">
              
              <div class="features clearfix">
			<h4><b>GIRLS</b></h4>
				1. Pink full sleeves shirt with school logo. <br>
				2. Grey box pleated Skirt ( Pre-Primary to VIII)<br>
				3. Grey trousers/Grey box pleated skirt (IX to X) <br>
				4. Half Sleeves Red Colour Sweater with Grey Border (Pre-Primary to X)<br>
				5. Red &amp; Grey Check Jacket  (Pre-Primary to IV) and Blue Blazer with school logo(V to X)<br>
				6. School belt, I card , White ribbon or band,  and Navy-Blue socks with pink stripes/cream coloured stockings. <br>
				7. Black Leather Shoes with velcro (Pre-Primary to VIII), Black Leather Shoes with Buckle (IX to X) <br>
				8. Gray Cap and Gloves (Optional)<br>
			<h4><b>BOYS</b></h4>
				1. Pink full sleeves shirt with school logo. <br>
				2. Grey  Trousers (Pre-Primary to X) <br>
				3. Half Sleeves Red Colour Sweater with Grey Border (Pre-Primary to X)<br>
				4. Red &amp; Grey Check Jacket  (Pre-Primary to IV) and Blue Blazer with school logo (V to X) <br>
				5. School belt, I card and Navy-Blue socks with  Pink stripes . <br>
				6. Black Leather Shoes with velcro (Pre-Primary to VIII), Black Leather Shoes with laces (IX to X).<br>
				7. Pink  dastar/Turban for sikh boys.<br>
				8. Gray Cap and Gloves (Optional) <br>
			
				   </div>
			  
            </div>

          </div>

        </div>

      </div>






	<section id="features" class="features">
      <div class="container">
		<div class="row feature-item">
		<div class="col-lg-6">
			<img src="assets/img/rules/tracksuituniform.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h3><br><b>Winter House Uniform (I to X )</b></h3><br>
		
			House Colour <br>
			Wordsworth House: Green<br>
			Coleridge House: Pink <br>
			Shelley House: Orange/Cyan <br>
			Shakespear House: Blue <br> <br>
		
			1. Track Suit of Navy Blue and Red Colour with school logo.<br>
			2. House Colour Inner.<br>
			3. White shoes with white socks. <br>
			4. I card, White ribbon or band and White socks. <br>
			5. White Leather Shoes with velcro.<br>
			6. White dastar/Turban for sikh boys.<br>
			7. Gray Cap and Gloves (Optional) <br>

			
          </div>
		  <div class="col-lg-6">
			<img src="assets/img/rules/pre-primaryhouseuniform.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h3><br><b>WINTER UNIFORM FOR PRE-PRIMARY <br>(WEDNESDAY &amp; SATURDAY)</b></h3> <br> <br>
		
		
			1. Track Suit of Navy Blue and Red Colour with school logo. <br>
			2. I card, White ribbon or band and Blue socks with Pink stripes. <br>
			3. Black Leather Shoes with velcro.<br>
			4. White dastar for sikh boys.<br>
			5. Gray Cap and Gloves (Optional) <br>

			
          </div>
		  </div>		  
			
         
      </div>
    </section><!-- End Features Section -->
	
	
  </section></main>